import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '@optools/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@optools/components/ui/form';
import { Input } from '@optools/components/ui/input';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const formSchema = z.object({
  broadcastName: z.string().trim().min(1, { error: 'Broadcast name is required' }),
  relayUrl: z
    .string()
    .trim()
    .min(1, { error: 'Relay URL is required' })
    .pipe(
      z.url({
        error: 'Enter a valid HTTP(S) relay URL',
        protocol: /^https?$/,
      }),
    ),
});

export type MoqSourceFormType = z.infer<typeof formSchema>;

export interface MoqSourceFormProps {
  onSubmit: (values: MoqSourceFormType) => void;
}

export function MoqSourceForm({ onSubmit }: MoqSourceFormProps) {
  const form = useForm<MoqSourceFormType>({
    defaultValues: {
      broadcastName: '',
      relayUrl: '',
    },
    resolver: zodResolver(formSchema),
  });

  return (
    <Form {...form}>
      <form
        className="grid min-w-0 grid-cols-[minmax(10rem,2fr)_minmax(5rem,1fr)_auto] gap-x-4 gap-y-2"
        noValidate
        onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          control={form.control}
          name="relayUrl"
          render={({ field }) => (
            <FormItem className="contents">
              <FormLabel className="col-start-1 row-start-1">Relay URL</FormLabel>
              <FormControl className="col-start-1 row-start-2 w-full self-end">
                <Input {...field} placeholder="https://relay.example.com/anon" type="url" />
              </FormControl>
              <FormMessage className="col-start-1 row-start-3" />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="broadcastName"
          render={({ field }) => (
            <FormItem className="contents">
              <FormLabel className="col-start-2 row-start-1">Broadcast Name</FormLabel>
              <FormControl className="col-start-2 row-start-2 w-full self-end">
                <Input {...field} />
              </FormControl>
              <FormMessage className="col-start-2 row-start-3" />
            </FormItem>
          )}
        />
        <Button className="col-start-3 row-start-2 self-end" type="submit">
          Submit
        </Button>
      </form>
    </Form>
  );
}
